import getConstructorType from './getConstructorType';

export default function addCommasToNumber(x) {
	// 非文字則轉為文字
  if(getConstructorType(x) !== 'string') x = x.toString();
  // 拆分小數點左側與右側
  const parts = x.split('.');
  // 左側加入千分位
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	// 合併並回傳字串
	return parts.join('.');
};


// 值為0時顯示空白
export function numberHandler(x) {
  const valueWithCommas = addCommasToNumber(x);
	return valueWithCommas === '0' ? '' : valueWithCommas;
};


// WEBPACK FOOTER //
// ./src/commonJS/addCommasToNumber.js